import { defineIntegration, consoleSandbox } from '@sentry/core';
import { FAKE_FUNCTION } from './common.js';
import { DEBUG_BUILD } from './debug-build.js';

function logShim(_message, _attributes) {
  DEBUG_BUILD && consoleSandbox(() => {
    console.warn("You are using Sentry.logger.* even though this bundle does not include logs.");
  });
}
function fmtShim(_strings, ..._values) {
  DEBUG_BUILD && consoleSandbox(() => {
    console.warn("You are using Sentry.logger.fmt even though this bundle does not include logs.");
  });
  return "";
}
const loggerShim = {
  trace: logShim,
  debug: logShim,
  info: logShim,
  warn: logShim,
  error: logShim,
  fatal: logShim,
  fmt: fmtShim
};
const consoleLoggingIntegrationShim = defineIntegration((_options) => {
  DEBUG_BUILD && consoleSandbox(() => {
    console.warn("You are using consoleLoggingIntegration() even though this bundle does not include logs.");
  });
  return {
    name: "ConsoleLogs",
    setup: FAKE_FUNCTION
  };
});

export { consoleLoggingIntegrationShim, loggerShim };
//# sourceMappingURL=logs.js.map
